import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  UserCircleIcon,
  CreditCardIcon,
  CpuChipIcon,
  BuildingOffice2Icon,
  ShieldCheckIcon,
  GlobeAltIcon
} from '@heroicons/react/24/outline';

const TabNavigation = ({ activeTab, setActiveTab, layout = 'vertical' }) => {
  const { t } = useTranslation();
  const tabs = [
    { id: 'profile', name: t('userProfile.tabs.profile'), icon: UserCircleIcon },
    { id: 'subscription', name: t('userProfile.tabs.subscription'), icon: CreditCardIcon },
    { id: 'ai', name: t('userProfile.tabs.ai'), icon: CpuChipIcon },
    { id: 'workspace', name: t('userProfile.tabs.workspace'), icon: BuildingOffice2Icon },
    { id: 'mcp', name: t('userProfile.tabs.mcp'), icon: GlobeAltIcon },
    { id: 'security', name: t('userProfile.tabs.security'), icon: ShieldCheckIcon }
  ];

  const isHorizontal = layout === 'horizontal';

  return (
    <div className="relative z-10">
      <nav
        className={isHorizontal ? 'flex flex-wrap gap-2' : 'space-y-1'}
        aria-label="Tabs"
      >
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`
              ${isHorizontal ? 'inline-flex' : 'w-full flex'}
              items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors
              ${activeTab === tab.id
                ? 'bg-white text-gray-900 shadow-sm ring-1 ring-neutral-200'
                : 'text-gray-700 hover:bg-white'}
            `}
            aria-current={activeTab === tab.id ? 'page' : undefined}
          >
            <Icon className="h-4 w-4" />
            <span>{tab.name}</span>
          </button>
        );
        })}
      </nav>
    </div>
  );
};

export default TabNavigation; 